<template lang='pug'>
  router-link.nav-item.nav-dropdown(tag='li', :to='url', disabled='')
    .nav-link.nav-dropdown-toggle(@click='handleClick')
      i(:class='icon')
      |  {{name}}
    ul.nav-dropdown-items
      slot
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarNavDropdown.vue